import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
} from "../services/types/ComponentTypes";

export const hrmAttendanceConfig: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Attendance",
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#f3f4f6",
                    padding: 12,
                    margin: 0,
                },
                childComponents: [
                    {
                        componentType: ComponentType.CUSTOM,
                        customType: "attendanceAdminTabs",
                    },
                    {
                        componentType: ComponentType.INFO_CARDS,
                        apiname: "/g360/hrms/attendance/statistics",
                        cards: [
                            {
                                name: "Present Days",
                                bindValue: "present_days",
                                icon: "✔️",
                                color: "#34D399",
                                defaultValue: 0,
                                valueFormat: "number",
                            },
                            {
                                name: "Absent Days",
                                bindValue: "absent_days",
                                icon: "❌",
                                color: "#F97316",
                                defaultValue: 0,
                                valueFormat: "number",
                            },
                            {
                                name: "Late Arrivals",
                                bindValue: "late_arrivals",
                                icon: "⏰",
                                color: "#FACC15",
                                defaultValue: 0,
                                valueFormat: "number",
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        childComponents: [
                            {
                                componentType: LayoutTypes.GRID,
                                columnNumber: "m1 t3 w1",
                                childComponents: [
                                    {
                                        componentType: ComponentType.CHECK_IN_OUT_COMPONENT,
                                        dataApi: "checkinout_info",
                                        onPressAction: "checkinout",
                                        logButtonAction: "attendanceSessionSummarylist",
                                        visibility: [2],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            backgroundColor: "hsl(var(--bg-white))",
                            padding: 12,
                            margin: 0,
                            borderRadius: 12,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.CUSTOM,
                                customType: "monthFilter",
                                Json_Attribute: "month_year",
                                name: "attendance_month_filter",
                                props: {
                                    filterField: "month / year",
                                },
                            },
                            {
                                componentType: ComponentType.SUMMARY_LIST,
                                titleValue: "attendance_date",
                                apiname: "attendance_summary",
                                Name: "attendance_summary",
                                TableName: "employee_attendance",
                                View: "v_attendance_status",
                                DisplayName: "Attendance Records",
                                SummeryActions: [
                                    {
                                        ActionType: "view",
                                        Action: {
                                            Action: "open_popup_2208_attendance_sessions",
                                        },
                                        Label: "Sessions",
                                        popup: true,
                                        visibility: [1, 2],
                                    },
                                ],
                                fields: [
                                    {
                                        IncludeLabel: true,
                                        Label: "Date",
                                        BindValue: "date_attendance",
                                        Json_Attribute: "attendance_date",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Month",
                                        BindValue: "txt_month_year",
                                        Json_Attribute: "month_year",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Employee ID",
                                        BindValue: "txt_employee_id",
                                        Json_Attribute: "employee_id",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                        visibility: [1],
                                    } as any,
                                    {
                                        IncludeLabel: true,
                                        Label: "Employee",
                                        BindValue: "s_select_employee",
                                        Json_Attribute: "employee_name",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                        visibility: [1],
                                    } as any,
                                    {
                                        IncludeLabel: true,
                                        Label: "Branch",
                                        BindValue: "s_select_branch",
                                        Json_Attribute: "branch_name",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                        visibility: [1],
                                    } as any,
                                    {
                                        IncludeLabel: true,
                                        Label: "First Check In",
                                        BindValue: "txt_first_check_in",
                                        Json_Attribute: "first_check_in",
                                        ControlType: "DateTime",
                                        AutoPopulate_format: "time",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Last Check Out",
                                        BindValue: "txt_last_check_out",
                                        Json_Attribute: "last_check_out",
                                        ControlType: "DateTime",
                                        AutoPopulate_format: "time",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Total Hours",
                                        BindValue: "txt_total_hours",
                                        Json_Attribute: "total_hours",
                                        ControlType: "TextView",
                                        AutoPopulate_format: "duration",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Sessions",
                                        BindValue: "txt_session_count",
                                        Json_Attribute: "session_count",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Late Duration",
                                        BindValue: "txt_late_duration",
                                        Json_Attribute: "late_duration",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Status",
                                        BindValue: "txt_status",
                                        Json_Attribute: "status",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Leave Type",
                                        BindValue: "txt_leave_type",
                                        Json_Attribute: "leave_type",
                                        ControlType: "TextView",
                                        showInSummary: true,
                                    },
                                ],
                            },
                        ],
                    }
                
                ],
            },
        ],
    },
];
